module.exports = __webpack_public_path__ + "img/animals_05_V.ed4ea358.webp";